import { So5FixtureEvent } from '__generated__/globalTypes';
import { useConfigContext } from 'contexts/config';

export const useNextSo5FixtureTeamSlugs = (
  eventType: So5FixtureEvent = So5FixtureEvent.CLASSIC
) => {
  const {
    so5: { teamsPlayingNextClassicGameWeeks, teamsPlayingNextDailyGameWeeks },
  } = useConfigContext();

  return eventType === So5FixtureEvent.CLASSIC
    ? teamsPlayingNextClassicGameWeeks
    : teamsPlayingNextDailyGameWeeks;
};
